import { SBModel } from '@supplement-bacon/react-toolkit/models'
import { Localizable } from './Localizable'

interface WhatsappBotSetting
  extends SBModel, Localizable<WhatsappBotSettingLocalizable> {
  key: string
  venueId: number
}

interface WhatsappBotSettingLocalizable {
  value: string
}

enum WhatsappBotSettingKey {
  WELCOME_MESSAGE = 'welcomeMessage',
  MORE_INFORMATION_BUTTON = 'moreInformationButton',
  HOME_BUTTON = 'homeButton',
  MENU_BUTTON = 'menuButton',
  SHOW_MAP_BUTTON = 'showMapButton',
  MORE_INFORMATION_FOLLOW_UP_TEXT = 'moreInformationFollowUpText',

  BOOKING_BUTTON = 'bookingButton',
  BOOKING_FLOW_BUTTON = 'bookingFlowButton',
  BOOKING_FLOW_MESSAGE = 'bookingFlowMessage',

  MANAGE_BOOKING_BUTTON = 'manageBookingButton',
  MANAGE_BOOKING_FLOW_MESSAGE = 'manageBookingFlowMessage',
  MANAGE_BOOKING_FLOW_BUTTON = 'manageBookingFlowButton',
  MANAGE_BOOKING_FLOW_NO_UPCOMING_RESERVATION = 'manageBookingFlowNoUpcomingReservation',

  AFTER_BOOKING_MESSAGE = 'afterBookingMessage',
  AFTER_BOOKING_UPDATE_MESSAGE = 'afterBookingUpdateMessage',
  AFTER_BOOKING_CANCEL_MESSAGE = 'afterBookingCancelMessage',
  LINK_PAYMENT_MESSAGE = 'linkPaymentMessage',
}

enum WhatsappBotSettingKeyInputType {
  inputText = 'inputText',
  textarea = 'textarea',
  venueIdInputText = 'venueIdInputText',
  venueIdTextarea = 'venueIdTextarea',
}

const whatsappBotSettingsByType: Record<
  WhatsappBotSettingKey,
  WhatsappBotSettingKeyInputType
> = {
  // inpuText
  [WhatsappBotSettingKey.BOOKING_BUTTON]:
    WhatsappBotSettingKeyInputType.inputText,
  [WhatsappBotSettingKey.MANAGE_BOOKING_BUTTON]:
    WhatsappBotSettingKeyInputType.inputText,
  [WhatsappBotSettingKey.MORE_INFORMATION_BUTTON]:
    WhatsappBotSettingKeyInputType.inputText,
  [WhatsappBotSettingKey.HOME_BUTTON]: WhatsappBotSettingKeyInputType.inputText,
  [WhatsappBotSettingKey.MENU_BUTTON]: WhatsappBotSettingKeyInputType.inputText,
  [WhatsappBotSettingKey.SHOW_MAP_BUTTON]:
    WhatsappBotSettingKeyInputType.inputText,

  // textarea
  [WhatsappBotSettingKey.MANAGE_BOOKING_FLOW_NO_UPCOMING_RESERVATION]:
    WhatsappBotSettingKeyInputType.textarea,

  //venueIdInputText
  [WhatsappBotSettingKey.BOOKING_FLOW_BUTTON]:
    WhatsappBotSettingKeyInputType.venueIdInputText,
  [WhatsappBotSettingKey.MANAGE_BOOKING_FLOW_BUTTON]:
    WhatsappBotSettingKeyInputType.venueIdInputText,

  // venueIdTextarea
  [WhatsappBotSettingKey.WELCOME_MESSAGE]:
    WhatsappBotSettingKeyInputType.venueIdTextarea,
  [WhatsappBotSettingKey.MORE_INFORMATION_FOLLOW_UP_TEXT]:
    WhatsappBotSettingKeyInputType.venueIdTextarea,
  [WhatsappBotSettingKey.BOOKING_FLOW_MESSAGE]:
    WhatsappBotSettingKeyInputType.venueIdTextarea,
  [WhatsappBotSettingKey.MANAGE_BOOKING_FLOW_MESSAGE]:
    WhatsappBotSettingKeyInputType.venueIdTextarea,
  [WhatsappBotSettingKey.AFTER_BOOKING_MESSAGE]:
    WhatsappBotSettingKeyInputType.venueIdTextarea,
  [WhatsappBotSettingKey.AFTER_BOOKING_UPDATE_MESSAGE]:
    WhatsappBotSettingKeyInputType.venueIdTextarea,
  [WhatsappBotSettingKey.AFTER_BOOKING_CANCEL_MESSAGE]:
    WhatsappBotSettingKeyInputType.venueIdTextarea,
  [WhatsappBotSettingKey.LINK_PAYMENT_MESSAGE]:
    WhatsappBotSettingKeyInputType.venueIdTextarea,
}

export {
  WhatsappBotSettingKey,
  WhatsappBotSettingKeyInputType,
  whatsappBotSettingsByType,
}
export type { WhatsappBotSetting }
